import type {HTMLAttributes} from "react";
import {cn} from "@/lib/utils";
export type Ton = "ok" | "warn" | "bad" | "idle";
export type BadgeTone = Ton | "neutral" | "info" | "ai" | "outline";
export function Badge({ton="idle",tone=ton,children,className,...props}:HTMLAttributes<HTMLSpanElement>&{ton?:Ton;tone?:BadgeTone}) { return <span className={cn("avm-badge",`avm-badge--${tone==="idle"?"neutral":tone}`,className)} {...props}>{children}</span>; }
